import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreKey } from '@app/shared';

@Injectable()
export class JWTRequestInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokenJwt = sessionStorage.getItem(StoreKey.TOKEN);
    const JWT = tokenJwt && tokenJwt != 'undefined' ? `Bearer ${tokenJwt}` : null;
    const body = req.body;

    const newHeaders: { [key: string]: string | undefined } = {};
    if (!req.headers.get('x-Multi-Part')) {
      newHeaders['Content-Type'] = req.headers.get('Content-Type') === null ? 'application/json' : req.headers.get('Content-Type')!;
    }
    if (JWT) newHeaders['Authorization'] = JWT;

    req = req.clone({
      setHeaders: newHeaders as { [key: string]: string },
      body,
      withCredentials: !!JWT,
    });
    return next.handle(req);
  }
}
